import {
  GAME_SCROLL_SAVE_REQUEST,
  GAME_SCROLL_USE_REQUEST,
  GAME_SCROLL_CLEAR,
} from '../constants/game';

export const scrollSave = () => ({
  type: GAME_SCROLL_SAVE_REQUEST,
});

export const scrollUse = action => ({
  type: GAME_SCROLL_USE_REQUEST,
  action,
});

export const scrollClear = () => ({
  type: GAME_SCROLL_CLEAR,
});
